import "../stylesheets/App.css";
import "../stylesheets/Ranking.css";
import React, { useEffect, useState } from "react";
import StageItem from "./subcomponents/StageItem.js";
import UserItem from "./subcomponents/UserItem.js";
import Header from "./subcomponents/Header.js";
import Loader from "./subcomponents/Loader.js";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

function Ranking() {
  const navigate = useNavigate();

  const [loadingUsers, setLoadingUsers] = useState(true);
  const [loadingIsAdmin, setLoadingIsAdmin] = useState(true);

  const [activePage, setActivePage] = useState(1);
  const [pages, setPages] = useState([1]);

  const [users, setUsers] = useState([]);
  const [isAdmin, setIsAdmin] = useState(0);
  const [categoryActive, setCategoryActive] = useState(1);

  const apiCall = (url, consecuencia) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => consecuencia(data))
      .catch((error) => console.log(error));
  };

  const updateIsAdmin = (data) => {
    setIsAdmin(data?.data ? 1 : 0);
    setLoadingIsAdmin(false);
  };

  const updateUsers = (data) => {
    setUsers(data?.data || []);

    // paginado seguro
    const total = data?.total || 0;
    const cant = total % 20 === 0 ? Math.trunc(total / 20) : Math.trunc(total / 20) + 1;

    const vec = [];
    for (let i = 1; i <= Math.max(cant, 1); i++) vec.push(i);

    setPages(vec);
    setLoadingUsers(false);
  };

  useEffect(() => {
    // ✅ 1) si no está logueado -> login (evita crash / pantalla en blanco)
    const raw = localStorage.getItem("user-info");
    if (!raw) {
      navigate("/login");
      return;
    }

    const parsed = JSON.parse(raw);

    // ✅ 2) ocultar buscador sin romper si no existe
    const search = document.getElementById("search-container");
    if (search) search.style.visibility = "hidden";

    // ✅ 3) validar admin en back (sin asumir)
    apiCall(
      `${process.env.REACT_APP_API_BASE_URL}/admin/is-admin/${parsed.idUser}`,
      updateIsAdmin
    );
  }, [navigate]);

  useEffect(() => {
    setActivePage(1);
  }, [categoryActive]);

  useEffect(() => {
    // ✅ si por cualquier motivo no hay sesión, no llamo APIs
    const raw = localStorage.getItem("user-info");
    if (!raw) return;

    setLoadingUsers(true);
    const pageForApi = activePage - 1;

    apiCall(
      `${process.env.REACT_APP_API_BASE_URL}/users/orderListWithPagination/${categoryActive}/${pageForApi}`,
      updateUsers
    );
  }, [categoryActive, activePage]);

  const stage = {
    idStage: 7,
    name: "Ranking global",
    total_score: 50,
    partial_score: 20,
    background_url: "\\\\images\\\\stage_banners\\\\BROWN_CARD.png",
    character_url: "\\\\images\\\\stage_characters\\\\BROWN_RANKING.png",
    active: 1,
  };

  return (
    <>
      <Header />
      <section className="stage-page ranking-page">
        <StageItem stage={stage} />
      </section>

      <section className="users-list">
        {users.map((user, i) => (
          <UserItem
            user={user}
            key={`user-${user?.idUser || i}`}
            index={(activePage - 1) * 20 + i + 1}
            onClick={
              isAdmin === 1
                ? () => navigate(`/admin/detail/${user.idCategory}/${user.idUser}`)
                : undefined
            }
          />
        ))}
      </section>

      <section className="admin-list-paginator-section">
        {pages.length > 1 ? (
          <FontAwesomeIcon
            icon={solid("chevron-left")}
            className="opacity-50 cursor-pointer hover:opacity-100"
            onClick={() => (activePage > 1 ? setActivePage(activePage - 1) : null)}
            size="sm"
          />
        ) : null}

        {pages.length > 1
          ? pages.map((page) =>
              page === 1 ||
              (page > activePage - 2 && page < activePage + 2) ||
              page === pages.length ? (
                <button
                  className={activePage === page ? "pag-item active" : "pag-item"}
                  key={`item-${page}`}
                  onClick={(e) => setActivePage(parseInt(e.currentTarget.value))}
                  value={page}
                >
                  {page}
                </button>
              ) : page === activePage - 2 || page === activePage + 2 ? (
                <span key={`dots-${page}`}>...</span>
              ) : null
            )
          : null}

        {pages.length > 1 ? (
          <FontAwesomeIcon
            icon={solid("chevron-right")}
            className="opacity-50 cursor-pointer hover:opacity-100"
            onClick={() => (activePage < pages.length ? setActivePage(activePage + 1) : null)}
            size="sm"
          />
        ) : null}
      </section>

      {loadingIsAdmin || loadingUsers ? <Loader /> : null}
    </>
  );
}

export default Ranking;
